import styled from 'styled-components';

const BreadcrumbStyle = styled.div`
	--catalog_breadcrumbDistance: var(--sp1-5x);

	position: relative;
	z-index: 8;

	padding-left: var(--catalog_contPaddingLR);
	padding-right: var(--catalog_contPaddingLR);

	.breadcrumb-inner-block {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: var(--catalog_breadcrumbDistance);

		&.additional-block {
			position: relative;
			background-color: var(--catalog_backgroundColor);

			&:after {
				content: '';
				position: absolute;
				bottom: 100%;
				width: 100%;
				height: calc(var(--catalog_contentDistance) * 3);
				background-color: var(--catalog_backgroundColor);
			}

			&:before {
				content: '';
				position: absolute;
				top: 100%;
				width: 100%;
				height: calc(var(--catalog_contentDistance) / 2);
				background-color: var(--catalog_backgroundColor);
			}
		}
	}

	svg {
		width: var(--sp0-5x);
		height: var(--sp0-5x);
	}

	/* .breadcrumb-item {
		transition: color var(--catalog_trTime) ease-out;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					color: var(--catalog_pink1000);
				}
			}
		}
	} */

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_DesktopSizeXLMin}) {
		--catalog_breadcrumbDistance: var(--sp1x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_DesktopSizeLMin}) {
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_DesktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_DesktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_TabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.catalog.mediaQuery.catalog_TabletSizeSMin}) {
	}
`;

export default BreadcrumbStyle;
